const TextActionFormStack = {
  border: "1px solid #bfbfbf",
  borderRadius: 1.2,
  padding: "2px 10px !important",
  width: "100%"
}
export default { TextActionFormStack }
